import React from "react";

export const getStatusIndicator = (status) => {
  const color = status === 'Active' ? 'green' : 'gray';
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <span style={{ color, fontSize: '26px', lineHeight: 1 }}>●</span>
      <span>{status}</span>
    </span>
  );
};

export function getWorkingDayOptions() {
  const options = [];
  for (let i = 1; i <= 23; i++) {
    options.push({ label: `WD${i}`, value: `WD${i}` });
  }
  return options;
}

export function getCalendarDayOptions() {
  const options = [];
  for (let i = 1; i <= 31; i++) {
    options.push({ label: String(i), value: String(i) });
  }
  return options;
}

export const validateAwsCronExpression = (expr) => {
  if (!expr?.trim()) return 'Cron expression is required';
  const parts = expr.trim().split(/\s+/);
  if (parts.length !== 6) return 'AWS cron must have 6 fields: minute hour day-of-month month day-of-week year';
  const [, , dom, , dow] = parts;
  if (dom !== '?' && dow !== '?') return 'Either day-of-month or day-of-week must be "?" (not both)';
  if (dom === '?' && dow === '?') return 'day-of-month and day-of-week cannot both be "?"';
  return null;
};

export const formatDatasetUrl = (url) => {
  if (!url) return { name: 'Unknown Dataset', id: 'N/A', fullUrl: '#' };
  
  // Extract dataset ID from QuickSight URL
  const match = url.match(/data-sets\/([a-f0-9-]+)/);
  const datasetId = match ? match[1] : 'Unknown ID';
  
  // Extract dataset name from URL path (after the last slash before query params)
  const nameMatch = url.match(/\/([^/?]+)(?:\?|$)/);
  let datasetName = 'Dataset';
  
  if (nameMatch && nameMatch[1] !== datasetId) {
    // If we found a name that's different from the ID, use it
    datasetName = decodeURIComponent(nameMatch[1]).replace(/[-_]/g, ' ');
  } else {
    // Try to extract from a different pattern or use ID as fallback
    const pathParts = url.split('/');
    const relevantPart = pathParts.find(part => 
      part && 
      part !== 'data-sets' && 
      part !== datasetId && 
      !part.includes('?') &&
      part.length > 3
    );
    
    if (relevantPart) {
      datasetName = decodeURIComponent(relevantPart).replace(/[-_]/g, ' ');
    }
  }
  
  return {
    name: datasetName,
    id: datasetId,
    fullUrl: url
  };
};